import { render, staticRenderFns } from "./ReviewsBar.vue?vue&type=template&id=0430657b&scoped=true&"
import script from "./ReviewsBar.vue?vue&type=script&lang=ts&"
export * from "./ReviewsBar.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewsBar.vue?vue&type=style&index=0&id=0430657b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0430657b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsRatingStarsBar: require('/var/www/packages/theme/components/atoms/RatingStarsBar.vue').default})
